export const PADDING_LEFT = 25;
export const LABEL_WIDTH = 280;
export const COLUMN_WIDTH = 80;
